const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;

export function niceDuration(ms: number) {
  if (ms < MINUTE) {
    return 'Less than a minute';
  }

  if (ms < HOUR) {
    const minutes = Math.round(ms / MINUTE);
    return `About ${minutes} minute${minutes > 1 ? 's' : ''}`;
  }

  const hours = Math.floor(ms / HOUR);
  const minutes = Math.round((ms - hours * HOUR) / MINUTE);

  return `About ${hours} hour${hours > 1 ? 's' : ''}, ${minutes} minute${minutes > 1 ? 's' : ''}`;
}
